<template>
  <el-dialog
    title="新增/编辑banner"
    :visible.sync="isVisible"
    width="900px"
    @close="handleClose"
  >
    <el-form
      :model="packageForm"
      ref="formRef"
      :rules="rules"
      label-width="140px"
      :inline="false"
    >
      <el-form-item label="banner图片" prop="pictureUrl">
        <el-upload
          v-loading="loading"
          class="avatar-uploader"
          :action="fileUp"
          :show-file-list="false"
          :headers="token"
          :accept="'image/jpeg,image/png,image/gif'"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="packageForm.pictureUrl" :src="showImgUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <p style="width: 100%;" slot="tip">尺寸建议：3840*1200</p>
        </el-upload>
      </el-form-item>

      <el-form-item label="跳转链接" prop="url">
        <el-radio-group v-model="packageForm.position">
          <el-radio :label="1">首页</el-radio>
          <el-radio :label="2">知识库</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="跳转链接" prop="url">
        <el-input
          v-model.trim="packageForm.url"
          type="text"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submitForm('formRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fileUp, fileEcho } from "@/api/url";
import { bannerAdd, banneEdit } from "@/api/banner";
export default {
  name: "ManagementSideCreate",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentBanner: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {
      token: { Authorization: "Bearer " + sessionStorage.getItem("token") },
      packageForm: {
        url: "",
        pictureUrl: "",
        position: 1,
      },
      showImgUrl: "",
      rules: {
        pictureUrl: [
          { required: true, message: "banner图不能为空", trigger: "blur" },
        ],
      },
      fileUp,
      loading: false,
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      const {
        url = "",
        pictureUrl = "",
        id = undefined,
        position = 1,
      } = this.currentBanner;
      this.packageForm.url = url;
      this.packageForm.pictureUrl = pictureUrl;
      this.packageForm.id = id;
      this.showImgUrl = fileEcho + pictureUrl;
      this.packageForm.position = position;
    },
    handleClose() {
      this.isVisible = false;
    },
    handleAvatarSuccess(res, file) {
      this.loading = false;
      this.packageForm.pictureUrl = res.location;
      this.showImgUrl = fileEcho + res.location;
    },
    beforeAvatarUpload(file) {
      this.loading = true;
      const isImgType =
        ["image/jpeg", "image/png", "image/gif"].indexOf(file.type) !== -1;
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImgType) {
        this.$message.error("图片只能是 JPG、PNG、GIF 格式!");
        this.loading = false;
      }
      // if (!isLt2M) {
      //   this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      return isImgType;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const path = this.packageForm.id ? banneEdit : bannerAdd;
          const method = this.packageForm.id ? "put" : "post";
          this.$ajax[method](path, this.packageForm).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(res.data.msg);
              this.isVisible = false;
              this.$emit("refresh");
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input-number {
  width: 100% !important;
}
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
.avatar-uploader {
  width: 300px;
}
.avatar-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  left: 0;
  right: 0;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 140px;
  display: block;
  object-fit: cover;
}
</style>
